<script setup lang="ts">
import RadioInput from "~/components/Common/Inputs/RadioInput.vue";

const props = withDefaults(
  defineProps<{
    modelValue?: string | number | boolean | null;
    value: string | number | boolean;
    disabled?: boolean;
    align?: "center" | "start";
  }>(),
  {
    disabled: false,
    align: "center",
  },
);

const emit = defineEmits<{
  (e: "update:modelValue", value: string | number | boolean): void;
}>();

const localValue = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val as string | number | boolean),
});
</script>

<template>
  <label class="radio_card__container" :class="align === 'start' ? 'items-start' : 'items-center'">
    <slot />
    <RadioInput v-model="localValue" :value="value" :disabled="disabled" />
  </label>
</template>

<style scoped lang="scss">
.radio_card__container {
  @apply flex p-[14px] justify-between w-full;
  background: var(--white-main);
  border: 1px var(--border-style) var(--grey-lightest);
  border-radius: 8px;

  &:has(input[type="radio"]:not([disabled])) {
    @apply cursor-pointer;

    &:hover {
      border-color: var(--primary-blue-color);
    }

    &:has(input:checked) {
      border-color: var(--primary-blue-color);
    }
  }

  &:has(input[type="radio"]:disabled) {
    color: var(--text-tertiary-color);
  }
}
</style>
